<div [hidden]="!isLoading">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
  <span class="message">{{ message }}</span>
</div>
